export const STOP = "stop";

export const stopAll = (elem: any) => {
  const event = new CustomEvent(STOP, { detail: elem });
  document.dispatchEvent(event);
};
